export enum AudioState {
    PLAYING = 'Playing',
    PAUSED = 'Paused',
    STOPPED = 'Stopped'
}
